
export const getFormattedDate = (date) => {
  return date ? `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}` : '...'
}
export const getStringDate = (date) => {
  return date ? `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}` : undefined
}

export const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const fromDateToStringDate = (date, isShortYear) => {
  if(!date) return ''
  let day = date.split('-')[2]
  let month = date.split('-')[1]
  let year = date.split('-')[0]
  return `${day}.${month}.${isShortYear ? year.substring(2, 4) : year}`
}

export const fromStringDateToDate = (date) => {
  let day = date.split('.')[0]
  let month = date.split('.')[1]
  let year = date.split('.')[2]
  return `${year}-${month}-${day}`
}

export const testDate = (date) => {
  return /^(0[1-9]|1\d|2\d|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2}$/.test(date)
}
export const isCyrilic = (value) => {
  if(value.length === 0) return true
  if(!isNaN(value.trim(''))) return true
  return /[^а-я, 0-9, ^\\p{P}+$+]/i.test(value)
}
export const dayWithMonth = (date, t) => {
  let months = [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('june'), t('july'), t('aug'), t('sep'), t('oct'), t('nov'), t('dec')]
  const month = months[date.getUTCMonth()]
  return `${date.getUTCDate()} ${month}`
}